import { ReactElement } from 'react';
import { Field, useFormikContext } from 'formik';

// Types
import { IFacetProps, SearchRequest } from '../../../types';
import { StyledAccordion, StyledAccordionDetails, StyledAccordionSummary } from 'hooks/StyledComponents';
import { FormikDatePicker } from '../../../../forms';

export const Date = (props: IFacetProps): ReactElement => {
  const { facet, isExpanded, expandIcon, onToggleExpand } = props;
  const { values } = useFormikContext<SearchRequest>();
  const { displayValue, payloadEndValue, payloadStartValue } = facet;

  const minDate = values[payloadStartValue];
  const maxDate = values[payloadEndValue];

  return (
    <StyledAccordion key={displayValue} expanded={isExpanded} onChange={onToggleExpand}>
      <StyledAccordionSummary
        aria-controls={`${displayValue}-content`}
        expandIcon={expandIcon}
        id={`${displayValue}-header`}
      >
        {displayValue}
      </StyledAccordionSummary>
      <StyledAccordionDetails>
        <div className="eyebrow">From:</div>
        <Field name={payloadStartValue}>
          {({ field }) => (
            <FormikDatePicker field={field} format={'MM/DD/YYYY'} formikKey={payloadStartValue} maxDate={maxDate} />
          )}
        </Field>

        <div className="eyebrow">To:</div>
        <Field name={payloadEndValue}>
          {({ field }) => (
            <FormikDatePicker field={field} format={'MM/DD/YYYY'} formikKey={payloadEndValue} minDate={minDate} />
          )}
        </Field>
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};
